/**
 * Formats error keys that contain special characters like brackets and colons.
 * Transforms keys like '[SDC5178:BD:1]' to 'SDC5178_BD_1' for locale lookup.
 * Normal string errors are returned as-is.
 * 
 * @param {string} error - The error key from API response
 * @returns {string} - Formatted error key safe for locale lookup
 */
export const formatErrorKey = error => {
    if (!error) return ''
    
    // Only transform if error contains brackets
    if (error.includes('[') && error.includes(']')) {
        return error
            .replace(/\[/g, '')
            .replace(/\]/g, '')
            .replace(/:/g, '_')
    }
    
    // Return as-is for normal strings
    return error
}
